import { PropsWithChildren } from 'react'
import Styles from './BackgroundsTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props
  extends PropsWithChildren<{
    name: string
  }> {}

export const SuggestedCategoriesGroup = (props: Props) => {
  const { isMobile } = useResponsiveDesign()
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const descriptionVariant = isSystemRedesignEnabled ? 'secondary' : 'largeList'

  return (
    <div className={Styles.suggestedCategoriesGroup}>
      <div className={Styles.suggestedCategoriesGroupTitle}>
        <Text variant={isMobile ? 'smallList' : descriptionVariant}>{props.name}</Text>
      </div>
      <div className={Styles.suggestedCategories}>{props.children}</div>
    </div>
  )
}
